// Pager for tables over one page (constitution §5.6: tables paginate above 100 rows).
export function Pager(props: {
  readonly page: number;
  readonly pageSize: number;
  readonly total: number;
  readonly label: string;
  readonly onPage: (page: number) => void;
}): React.JSX.Element | null {
  const pages = Math.max(1, Math.ceil(props.total / props.pageSize));
  if (pages <= 1) return null;
  const page = Math.min(props.page, pages);
  return (
    <nav className="pager" aria-label={`${props.label} pages`}>
      <button
        type="button"
        className="btn btn--secondary"
        disabled={page <= 1}
        onClick={() => props.onPage(page - 1)}
      >
        Previous
      </button>
      <span aria-live="polite">
        Page {page} of {pages}
      </span>
      <button
        type="button"
        className="btn btn--secondary"
        disabled={page >= pages}
        onClick={() => props.onPage(page + 1)}
      >
        Next
      </button>
    </nav>
  );
}
